import { analytics_methods } from "../../utils/analytics_methods";
import addKeysToSchema from "./schema";


function triggerEvent() {

    const schema = addKeysToSchema();

    const isAdult = true; // set this value because data analyst requirement
    const priceWithCommission = analytics_methods.calculatePrice(window?.analytics_buendia?.value_without_commission, isAdult);
    const itemId = window?.analytics_buendia?.cart_type === "b_sidebar_cart_tiqets" ? window?.analytics_buendia?.tiqets_id : window?.analytics_buendia?.activity_id;
    
    const data = {
        event: "view_item",
        event_type: "page_view",
        ecommerce: {
            value: priceWithCommission ?? null,
            currency: "EUR", // "EUR" is the only currency we are handling now, it's value is not present in the content, in the future if more currencies are added this should be grabbed dynamically
            items: [{
                item_id: itemId || null,
                item_name: window?.analytics_buendia?.activity_name || null,
                item_brand: window?.analytics_buendia?.item_brand || "",
                item_category: window?.analytics_buendia?.item_category || null,
                item_category2: window?.analytics_buendia?.item_category2 || null,
                origin: window?.analytics_buendia?.origin || null,
                price: priceWithCommission ?? null,
                quantity: 1, // set this value because data analyst requirement
            }]
        }
    }
    
    
    analytics_methods.sendToDataLayer(data, schema);
}



export const view_item_event = {
    triggerEvent
}